var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInspection01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n\t.st12{fill:url(#SVGID_13_);}\n\t.st13{fill:url(#SVGID_14_);}\n\t.st14{fill:url(#SVGID_15_);}\n\t.st15{fill:url(#SVGID_16_);}\n\t.st16{fill:url(#SVGID_17_);}\n\t.st17{fill:url(#SVGID_18_);}\n\t.st18{fill:url(#SVGID_19_);}\n\t.st19{fill:url(#SVGID_20_);}\n\t.st20{fill:url(#SVGID_21_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.1,
    y1: 615.5292,
    x2: 797.4764,
    y2: 615.5292
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M303.3,236.4c1.4,17.5,2.6,32.4,4,49.2c-24.8,0-49.7,0-76.1,0c0,220.2,0,438.6,0,658.2 c172.1,0,343.6,0,516.8,0c0-20.4-0.7-39.5,0.5-58.6c0.3-5.1,5.7-12.2,10.5-14.3c11.4-5,23.8-7.5,38-11.7c0,36,1.4,71-0.6,105.9 c-0.9,16-13.9,26.2-30.5,28.7c-6.5,1-13.2,0.9-19.8,0.9c-171.9,0-343.8,0-515.7,0c-38.4,0-50.3-12-50.3-50.9 c0-218.8,0-437.6,0-656.4c0-38.9,12-50.9,50.3-51C254.2,236.3,278.1,236.4,303.3,236.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 517.6964,
    y1: 757.8315,
    x2: 1105.7896,
    y2: 757.8315
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M861.9,776.8c14.8,13.9,30,28.3,45.4,42.4c2.4,2.2,7.1,5.1,8.9,4.2c16.8-8.5,25.6,3.3,35.4,13.1 c46.7,46.7,93.6,93.3,140.2,140.1c18.9,19,18.6,25.4-0.6,44.4c-8.1,8-16,16.3-24.3,24.1c-9.4,8.7-19.8,9-28.9-0.1 c-52.4-52-104.6-104.3-156.7-156.7c-3.5-3.5-7.6-10.6-6.3-14c7-17.2-5.6-24.6-14.9-34.1c-10.1-10.3-19.9-20.8-30.7-32.2 c-53.4,37.8-110.8,50.5-173.1,32.7c-45.7-13.1-81.5-40.1-107.5-79.8C497.2,682,511,576.5,581.3,513.2c70.2-63.3,176-65.7,249.9-6.6 C895.2,557.7,937,666.8,861.9,776.8z M710.3,813.6c86.9-0.1,157.1-70.1,157.3-156.7c0.1-87.8-70.2-158.4-157.7-158.2 c-87.6,0.2-157.5,70.7-157.3,158.6C552.9,743.7,623.5,813.7,710.3,813.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.1194,
    y1: 229.5327,
    x2: 645.9243,
    y2: 229.5327
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M555.1,213.5c22.9,0,45,0.4,67.1-0.1c17-0.4,24.2,7.8,23.7,24.1c-0.2,6.6,0.1,13.2-0.1,19.8 c-1,30.6-20,51.9-50.4,52.3c-70.8,0.9-141.6,0.9-212.4,0.1c-31.6-0.4-50.1-21.3-50.7-53.4c-0.8-42.8-0.8-42.8,42.2-42.8 c3.6,0,7.2-0.3,10.8,0.1c22.4,2.4,38.9,1.3,46.4-27.7c6.8-26.4,31.7-37.7,59.7-37.1c26.2,0.6,48.6,16.7,57.7,41.5 C551.6,196.8,552.7,204,555.1,213.5z M489.8,184.3c-15.9-0.4-28.9,11.7-29.6,27.6c-0.7,15.2,12.3,29,27.9,29.5s29-12.1,29.4-27.8 C517.9,197.7,505.6,184.7,489.8,184.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 670.6,
    y1: 345.2866,
    x2: 797.9305,
    y2: 345.2866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M747.8,286.2c-27.5,0-52,0-77.2,0c1.1-16.3,2-31.5,3.1-48.2c31.9,0,64-1.8,95.8,0.7 c17.7,1.4,27.9,16.7,28.1,34.7c0.6,59.3,0.2,118.7,0.2,179.8c-16.9-4.9-32.6-9.4-50-14.4C747.8,388.8,747.8,338.7,747.8,286.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.5704,
    y1: 520.901,
    x2: 401.0272,
    y2: 520.901
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M328.8,530.4c15.1-15.9,27.8-29.4,40.6-42.9c7.5-7.9,16-14.7,26.2-5.2c10.2,9.6,4.3,18.3-3.6,26.2 c-15.8,15.7-31.6,31.3-47.1,47.2c-11.1,11.4-21.5,11.2-32.3-0.3c-7.4-7.9-16.8-14.4-22.2-23.4c-3.4-5.6-1-14.7-1.1-22.2 c7.5,0.5,16-1,22.3,2C317.5,514.6,321.3,522,328.8,530.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.4313,
    y1: 784.6683,
    x2: 401.0356,
    y2: 784.6683
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M330.3,792.7c14.5-15.3,27.7-29.2,40.9-43.2c7.5-7.9,16-11.9,24.9-3c9.1,9.1,4.2,17.4-3.3,24.9 c-16.2,16.1-32.3,32.2-48.4,48.4c-10.4,10.6-20.5,11-31,0c-7.9-8.3-17.6-15.2-23.4-24.7c-3.3-5.4-0.4-14.6-0.2-22.1 c7,0.4,15-1.1,20.9,1.7C317.3,777.9,322.1,784.9,330.3,792.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.444,
    y1: 651.8256,
    x2: 400.9958,
    y2: 651.8256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M330.4,660.8c14.6-15.4,27.8-29.4,41-43.3c7.6-8,16.5-11.2,25.1-2.4c8.1,8.3,4.1,16.6-2.9,23.6 c-16.9,17-34,34-51,50.9c-1.7,1.7-4,4.5-5.6,4.2c-8.1-1.6-18.9-1.5-23.3-6.6c-10.5-12.4-32.9-18.5-27.4-40.3 c2.9-11.5,13.7-12.8,23.2-5.6C316.1,646.3,321.7,652.6,330.4,660.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.6,
    y1: 810.3755,
    x2: 572.7,
    y2: 810.3755
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M434.6,826.8c0-10.9,0-20.3,0-32c33.9,0,67.5-2.6,100.3,1.3c12.4,1.5,23.1,18.1,37.8,30.6 C524,826.8,480.2,826.8,434.6,826.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.7,
    y1: 548.1,
    x2: 526.2,
    y2: 548.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M434.7,564.2c0-12.3,0-21.7,0-32.2c31,0,61.2,0,91.5,0c-12.4,32.2-12.4,32.2-43.9,32.2 C466.9,564.2,451.5,564.2,434.7,564.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.7,
    y1: 679.3,
    x2: 493.5,
    y2: 679.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M434.7,663.1c19.3,0,36.4,0,55.3,0c1.2,10.8,2.3,21.1,3.5,32.4c-20.3,0-39.1,0-58.8,0 C434.7,684.6,434.7,674.7,434.7,663.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 663.9,
    y1: 616.989,
    x2: 836.2926,
    y2: 616.989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M663.9,541.2c39.9-22.3,98.9-10.1,135.6,25.4c33.9,32.7,48.9,95.4,25.4,137.4c-0.1-46.3-15.1-84.8-46.5-116.2 C747.4,556.8,709.3,542,663.9,541.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.3,
    y1: 381.25,
    x2: 269.6,
    y2: 381.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M269.6,353.7v55.1h-17.3v-55.1H269.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.4,
    y1: 381.25,
    x2: 330.3,
    y2: 381.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M330.3,408.8H313l-18.3-27.7v27.7h-17.3v-55.1h17.3l18.3,28.2v-28.2h17.3V408.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.3,
    y1: 381.1,
    x2: 380.9,
    y2: 381.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M343.3,404.7c-4.3-3.1-6.6-7.6-7-13.6h18.4c0.3,3.2,1.7,4.8,4.2,4.8c0.9,0,1.7-0.2,2.4-0.7 c0.6-0.4,1-1.1,1-2.1c0-1.3-0.7-2.3-2.1-3.2c-1.4-0.8-3.6-1.7-6.5-2.8c-3.5-1.2-6.5-2.5-8.8-3.7s-4.3-2.9-6-5.2 c-1.7-2.3-2.5-5.2-2.4-8.8c0-3.6,0.9-6.6,2.8-9.1c1.8-2.5,4.4-4.4,7.6-5.7c3.2-1.3,6.8-1.9,10.8-1.9c6.7,0,12.1,1.6,16.1,4.7 s6.1,7.5,6.3,13.2h-18.6c-0.1-1.6-0.4-2.7-1.2-3.3c-0.7-0.7-1.6-1-2.6-1c-0.7,0-1.3,0.2-1.8,0.7s-0.7,1.2-0.7,2.1 c0,1.2,0.7,2.3,2.1,3.1c1.4,0.8,3.6,1.8,6.6,2.9c3.5,1.3,6.3,2.5,8.6,3.7c2.3,1.2,4.2,2.9,5.9,5c1.7,2.1,2.5,4.8,2.5,8 c0,3.4-0.8,6.4-2.5,9.1s-4.1,4.8-7.2,6.3c-3.2,1.5-6.9,2.3-11.3,2.3C353,409.4,347.6,407.8,343.3,404.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.7,
    y1: 381.25,
    x2: 431.7084,
    y2: 381.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M429.4,382.1c-1.6,2.8-4,5.1-7.1,6.7c-3.1,1.7-6.9,2.5-11.4,2.5H404v17.5h-17.3v-55.1h24.1 c6.7,0,11.9,1.7,15.5,5.1s5.4,8,5.4,13.8C431.8,376.1,431,379.3,429.4,382.1z M414.3,372.6c0-3.4-1.8-5.1-5.4-5.1H404v10.1h4.9 C412.5,377.7,414.3,376,414.3,372.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.2,
    y1: 381.35,
    x2: 474,
    y2: 381.35
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M454.5,367.5v6.8h17.1v13h-17.1v7.8H474v13.8h-36.8v-55.1H474v13.8L454.5,367.5L454.5,367.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 479,
    y1: 381.3,
    x2: 533,
    y2: 381.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M482.3,366.6c2.2-4.3,5.4-7.6,9.5-9.9c4.1-2.4,8.9-3.5,14.5-3.5c4.8,0,9,0.9,12.8,2.7 c3.8,1.8,6.8,4.3,9.2,7.6c2.4,3.3,3.9,7.1,4.7,11.4h-18.2c-0.8-1.8-2-3.2-3.5-4.2s-3.3-1.5-5.3-1.5c-2.9,0-5.2,1.1-6.9,3.3 c-1.7,2.2-2.5,5.1-2.5,8.8c0,3.7,0.8,6.6,2.5,8.8c1.7,2.2,4,3.3,6.9,3.3c2,0,3.7-0.5,5.3-1.5c1.5-1,2.7-2.4,3.5-4.2H533 c-0.8,4.4-2.3,8.2-4.7,11.4c-2.4,3.3-5.4,5.8-9.2,7.6c-3.8,1.8-8,2.7-12.8,2.7c-5.6,0-10.4-1.2-14.5-3.5c-4.1-2.4-7.3-5.7-9.5-9.9 c-2.2-4.3-3.3-9.1-3.3-14.6S480.1,370.9,482.3,366.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 536.1,
    y1: 381.25,
    x2: 582.5,
    y2: 381.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M582.5,353.7v13.7h-14.6v41.4h-17.3v-41.4h-14.5v-13.7H582.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 587.1,
    y1: 381.25,
    x2: 604.4,
    y2: 381.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M604.4,353.7v55.1h-17.3v-55.1H604.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 610.7,
    y1: 381.05,
    x2: 667.4,
    y2: 381.05
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M624.8,405.7c-4.3-2.4-7.8-5.8-10.3-10.1c-2.5-4.3-3.8-9.2-3.8-14.6s1.3-10.3,3.8-14.6 c2.5-4.3,6-7.7,10.3-10.1s9.1-3.6,14.3-3.6s9.9,1.2,14.3,3.6c4.3,2.4,7.7,5.8,10.2,10.1c2.5,4.3,3.8,9.2,3.8,14.6 s-1.3,10.3-3.8,14.6c-2.5,4.3-5.9,7.7-10.3,10.1c-4.3,2.4-9.1,3.7-14.2,3.7C633.9,409.4,629.1,408.2,624.8,405.7z M647,390 c1.9-2.2,2.8-5.2,2.8-8.9c0-3.8-0.9-6.8-2.8-9c-1.9-2.2-4.5-3.3-7.9-3.3c-3.5,0-6.2,1.1-8,3.3c-1.9,2.2-2.8,5.2-2.8,9 c0,3.7,0.9,6.7,2.8,8.9c1.9,2.2,4.5,3.3,8,3.3C642.5,393.3,645.2,392.2,647,390z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 673.6,
    y1: 381.25,
    x2: 726.5,
    y2: 381.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M726.5,408.8h-17.3l-18.3-27.7v27.7h-17.3v-55.1h17.3l18.3,28.2v-28.2h17.3V408.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspection01);
export default __webpack_public_path__ + "static/media/Inspection-01.566269f1f9b4c24ff1b0c67ffaeaa1ab.svg";
export { ForwardRef as ReactComponent };